module.exports = __webpack_public_path__ + "img/dummy.8287eaab.jpg";